export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-checkbox/es/index.js
// module id = 328
// module chunks = 0